// Admin panel page → permission needed to open it.
// Module keys match the backend (ecom_pro_backend/utils/permissions.js).
// First match wins, so more specific prefixes come first.
const ROUTES = [
  ["/dashboard", "dashboard", "view"],

  ["/add-sub-categories", "sub_categories", "create"],
  ["/edit-sub-categories", "sub_categories", "edit"],
  ["/sub-categories", "sub_categories", "view"],
  ["/add-categories", "categories", "create"],
  ["/edit-categories", "categories", "edit"],
  ["/categories", "categories", "view"],

  ["/add-product", "products", "create"],
  ["/edit-product", "products", "edit"],
  ["/products", "products", "view"],
  ["/product-selection", "product_selection", "view"],

  ["/add-user", "users", "create"],
  ["/edit-user", "users", "edit"],
  ["/manage-users", "users", "view"],

  ["/add-role", "roles", "create"],
  ["/edit-role", "roles", "edit"],
  ["/roles", "roles", "view"],

  ["/add-order", "orders", "create"],
  ["/edit-order", "orders", "edit"],
  ["/orders", "orders", "view"],

  ["/add-purchase", "purchases", "create"],
  ["/edit-purchase", "purchases", "edit"],
  ["/purchase", "purchases", "view"],

  ["/reports", "reports", "view"],
  ["/stock-adjustments", "stock_adjustments", "view"],
  ["/warehouses", "warehouses", "view"],

  ["/add-coupon", "coupons", "create"],
  ["/edit-coupon", "coupons", "edit"],
  ["/manage-coupons", "coupons", "view"],

  ["/add-currency", "currency", "create"],
  ["/edit-currency", "currency", "edit"],
  ["/manage-currency", "currency", "view"],

  ["/add-customers", "customers", "create"],
  ["/edit-customer", "customers", "edit"],
  ["/manage-customers", "customers", "view"],
  ["/contact-submissions", "contact_submissions", "view"],

  ["/add-vendor", "vendors", "create"],
  ["/edit-vendor", "vendors", "edit"],
  ["/manage-vendor", "vendors", "view"],

  ["/add-faqs", "faqs", "create"],
  ["/edit-faqs", "faqs", "edit"],
  ["/faqs", "faqs", "view"],
  ["/add-terms", "terms", "create"],
  ["/edit-terms", "terms", "edit"],
  ["/terms", "terms", "view"],
  ["/add-policies", "policies", "create"],
  ["/edit-policies", "policies", "edit"],
  ["/policies", "policies", "view"],

  ["/add-review", "reviews", "create"],
  ["/edit-review", "reviews", "edit"],
  ["/view-review", "reviews", "view"],
  ["/manage-reviews", "reviews", "view"],
  ["/customer-order-reviews", "reviews", "view"],

  ["/live-chat", "live_chat", "view"],
  ["/plugins", "plugins", "view"],
  ["/ai-assistant", "ai_assistant", "view"],

  ["/hero-section", "home_content", "view"],
  ["/site-setup/hero-section", "home_content", "view"],
  ["/site-setup/coupons", "home_content", "view"],
  ["/site-setup", "setup", "view"],
  ["/api-docs", "setup", "view"],
];

export function permissionForPath(pathname = "") {
  const path = pathname.replace(/\/+$/, "") || "/";
  const hit = ROUTES.find(([prefix]) => path === prefix || path.startsWith(prefix + "/"));
  return hit ? { module: hit[1], action: hit[2] } : null;
}

// Pages to try (in order) when the user lands somewhere they can't open, e.g. /dashboard
export const LANDING_ORDER = [
  "/dashboard",
  "/orders",
  "/products",
  "/categories",
  "/manage-customers",
  "/purchase",
  "/reports",
  "/manage-users",
  "/roles",
  "/manage-reviews",
  "/live-chat",
  "/hero-section",
  "/site-setup",
];
